class VariantProductGallery extends HTMLElement {
  constructor() {
    super();
    this.thumbnails = this.querySelectorAll('.thumbnail-button');
    this.images = this.querySelectorAll('.gallery__image');
    this.variantSelects = document.querySelectorAll('select[data-variant-select]');
    
    this.bindEvents();
    this.initializeGallery();
  }

  bindEvents() {
    // Handle thumbnail clicks
    this.thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => this.setActiveImage(index));
    });

    // Handle variant changes
    this.variantSelects.forEach(select => {
      select.addEventListener('change', () => this.handleVariantChange());
    });
  }

  initializeGallery() {
    if (this.images.length > 0) {
      this.setActiveImage(0);
    }
  }

  setActiveImage(index) {
    // Remove active class from all images and thumbnails
    this.images.forEach(image => image.classList.remove('active'));
    this.thumbnails.forEach(thumbnail => thumbnail.classList.remove('active'));

    // Add active class to selected image and thumbnail
    this.images[index]?.classList.add('active');
    this.thumbnails[index]?.classList.add('active');
  }

  handleVariantChange() {
    const selectedOptions = Array.from(this.variantSelects).map(select => select.value);
    const variantTitle = selectedOptions.join(' / ');
    
    // Update visible images based on variant
    this.images.forEach(image => {
      const imageVariantTitle = image.querySelector('img').dataset.variantTitle;
      image.style.display = imageVariantTitle === variantTitle ? 'block' : 'none';
    });

    // Update thumbnails
    this.thumbnails.forEach((thumbnail, index) => {
      thumbnail.style.display = this.images[index].style.display;
    });

    // Reset to first image of new variant
    const firstVisibleIndex = Array.from(this.images).findIndex(image => 
      image.style.display === 'block'
    );
    if (firstVisibleIndex >= 0) {
      this.setActiveImage(firstVisibleIndex);
    }
  }
}

customElements.define('variant-product-gallery', VariantProductGallery);